const guia = {
  hero: {
    badge: 'Intelligence de Marché',
    title1: 'Guide des Prix par',
    title2: ' Quartier et Ville 2025',
    description: 'Comprenez les valeurs du marché local avec le prix moyen au m² / sq ft, les tendances annuelles et les scores des quartiers à Miami (Floride, États-Unis), São Paulo et Brasília.',
    statCities: '3 Villes',
    statNeighborhoods: '20 Quartiers',
    statTrends: 'Tendances sur 5 Ans',
    statAi: 'Données Générées par IA',
  },
  pulse: {
    title: 'Pouls du Marché',
    subtitle: '3 marchés · Dernières mises à jour',
    updated: 'Mis à jour le',
    viewGuide: 'Voir le guide',
    recentUpdates: 'mises à jour récentes',
    badgePrices: 'Prix',
    badgeTrend: 'Tendance',
    disclaimer: '<0>À des Fins Éducatives Uniquement — Avis sur les Données Générées par IA :</0> Les chiffres de prix moyen au m² / sq ft, les taux de croissance annuels et les scores des quartiers présentés sur cette page sont des estimations générées par IA, compilées à partir de rapports de marché accessibles au public, d\'indices immobiliers (FipeZAP, ZAP Imóveis, CondoBlackBook) et de sources tierces de 2024–2025. Ces données peuvent être obsolètes, incomplètes ou inexactes. Elles sont destinées exclusivement à des fins éducatives et informatives générales et ne constituent pas un conseil financier, d\'investissement ou immobilier. <1>Carvalho\'s Imobiliária n\'assume aucune responsabilité pour les erreurs, omissions ou décisions prises sur la base de ces informations.</1> Consultez toujours un professionnel de l\'immobilier agréé et effectuez une due diligence indépendante avant toute décision d\'investissement.',
  },
  citySelector: {
    title: 'Sélectionnez une Ville',
    subtitle: 'Cliquez pour explorer les quartiers et les données de prix',
    selected: 'Sélectionné',
    listings: 'annonces',
    avgPrice: 'Prix moyen',
    yoyGrowth: 'Crois. annuelle',
    viewFullGuide: 'Voir le guide complet de',
  },
  miamiDetail: {
    description: 'Miami est l\'un des marchés immobiliers de luxe les plus dynamiques au monde, attirant des investisseurs internationaux et des acheteurs ultra-fortunés. La ville allie style de vie tropical, commodités de classe mondiale et fort potentiel d\'appréciation. En 2025, les prix des condos de luxe ont dépassé 1 000 $/sq ft en moyenne pour la première fois de l\'histoire.',
    avgPrice: 'Prix Moyen',
    yoyGrowth: 'Crois. Annuelle',
    neighborhoods: 'Quartiers',
    activeListings: 'Annonces Actives',
    priceEvolution: 'Évolution du Prix Moyen',
    since2020: '+54,5 % depuis 2020',
    currentAvg: 'Moyenne actuelle (2025)',
    neighborhoodsTitle: 'Quartiers de Miami',
    neighborhoodsFound: '7 quartiers trouvés',
    searchPlaceholder: 'Rechercher des quartiers...',
    sortPrice: 'Prix',
    sortGrowth: 'Croissance',
    sortAZ: 'A–Z',
    pricePerSqft: 'Prix moyen par sq ft',
    yoyVar: 'Var. annuelle',
    walkability: 'Marchabilité',
    infrastructure: 'Infrastructure',
    appreciation: 'Valorisation',
    viewFullGuide: 'Voir le Guide Complet',
  },
  priceTable: {
    title: 'Comparaison Complète des Prix',
    subtitle: 'Tous les quartiers classés par prix moyen par unité',
    colNeighborhood: 'Quartier',
    colCity: 'Ville',
    colAvgPrice: 'Prix Moyen',
    colYoY: 'Var. Annuelle',
    colMarketType: 'Type de Marché',
    colListings: 'Annonces',
  },
  compare: {
    title: 'Outil Interactif',
    subtitle: 'Comparez les marchés côte à côte',
    description: 'Sélectionnez deux marchés et comparez les prix, le rendement, les scores d\'investissement et le profil idéal.',
    marketA: 'Marché A',
    marketB: 'Marché B',
    metric: 'Métrique',
    overview: 'Aperçu',
    returnYield: 'Rendement',
    investmentScores: 'Scores d\'Investissement (0–10)',
    overallScore: 'Score Global',
    profileAnalysis: 'Profil et Analyse',
    strengths: 'Points forts',
    risks: 'Risques principaux',
    viewAnalysis: 'Voir l\'analyse complète par quartier',
    viewMiamiGuide: 'Voir le guide de Miami',
    viewSPGuide: 'Voir le guide de São Paulo',
    footerNote: 'Les scores sont des estimations éditoriales basées sur des indices publics (FipeZAP, Zillow, T1 2025). Ils ne constituent pas un conseil financier.',
    of10: 'sur 10',
    currency: 'Devise',
    entryPrice: 'Prix d\'entrée (min.)',
    avgPrice: 'Prix moyen',
    topMarket: 'Haut de marché',
    yoyAppreciation: 'Valorisation annuelle',
    rentalYield: 'Rendement locatif',
    recommendedHorizon: 'Horizon recommandé',
    marketLiquidity: 'Liquidité du marché',
    appreciationPotential: 'Potentiel de valorisation',
    passiveIncome: 'Revenu passif',
    idealProfile: 'Profil d\'investisseur idéal',
    locationMiami: 'Floride, États-Unis',
    locationSP: 'São Paulo, Brésil',
    currencyA: 'USD · Dollar américain',
    currencyB: 'BRL · Réal brésilien',
    yieldA: '5–8% par an',
    yieldB: '4–6% par an',
    horizonA: '5–10 ans',
    horizonB: '3–10 ans',
    idealProfileA: 'Diversification internationale, protection de change et horizon à long terme (5–10 ans)',
    idealProfileB: 'Liquidité maximale, diversité des quartiers et exposition au plus grand hub financier d\'Amérique latine',
    strengthsA: ['0% impôt d\'État FL', 'Location courte durée viable', 'Marché international', 'Couverture de change BRL/USD', 'Valorisation cumulée +54% (5 ans)'],
    strengthsB: ['Plus grand marché d\'Amérique latine', 'Liquidité maximale', 'Diversité des quartiers et gammes', 'Hub corporate Faria Lima'],
    risksA: ['Risque de change (BRL/USD)', 'Coûts d\'entretien élevés', 'Assurances obligatoires (ouragans)', 'Bureaucratie pour non-résidents'],
    risksB: ['ITBI + charge fiscale élevée', 'Offre élevée dans certains quartiers', 'Valorisation plus progressive'],
  },
  country: {
    usa: 'États-Unis',
    brazil: 'Brésil',
  },
  cta: {
    title: 'Prêt à investir dans le bon quartier ?',
    specialist: 'Spécialiste en Intelligence de Marché',
    description: 'Nos spécialistes connaissent chaque marché sur le bout des doigts. Obtenez des conseils personnalisés dès aujourd\'hui.',
    whatsapp: 'Parler à un Expert sur WhatsApp',
    browse: 'Voir Toutes les Annonces',
  },
  spHighlight: {
    title: 'Itaim Bibi en tête de la valorisation à SP avec +11,3 % en glissement annuel au T1 2026',
    subtitle: 'Le couloir Faria Lima maintient une demande soutenue avec de nouveaux bureaux de fonds internationaux dans la région.',
  },
  brasiliaHighlight: {
    title: 'FipeZAP : DF en tête de la valorisation parmi les capitales avec +12,6 % en 2025',
    subtitle: 'Sudoeste et Noroeste tirent la hausse — le prix moyen à Plano Piloto atteint R$14 300/m².',
  },
  miamiHighlight: {
    title: 'Sunny Isles dépasse les 2 000 $/sq ft pour la première fois de l\'histoire',
    subtitle: 'Bentley Residences et Porsche Design Tower hissent le plancher des prix de la région à un niveau record.',
  },
  cityPages: {
    shared: {
      marketPulse: 'Market Pulse',
      updates: '3 mises à jour',
      updatedOn: 'Mis à jour le',
      disclaimerWarning: 'Avis',
      disclaimerMiami: 'Les données de prix sont des estimations basées sur des indices publics (CondoBlackBook, Zillow, T1 2025). Elles ne constituent pas un conseil financier. Consultez un professionnel avant toute décision d\'investissement.',
      disclaimerBR: 'Les données de prix sont des estimations basées sur des indices publics (FipeZAP, ZAP Imóveis, 2025). Elles ne constituent pas un conseil financier. Consultez un professionnel avant toute décision d\'investissement.',
      interactiveTool: 'Outil interactif',
      compareHeading: 'Comparez les marchés côte à côte',
      compareSubtitle: 'Sélectionnez deux marchés et comparez les prix, le rendement, les scores d\'investissement et le profil idéal.',
      marketA: 'Marché A',
      marketB: 'Marché B',
      vs: 'VS',
      metric: 'Métrique',
      overview: 'Aperçu',
      returnYield: 'Rendement',
      investmentScores: 'Scores d\'investissement (0–10)',
      overallScore: 'Score global',
      profileAnalysis: 'Profil et analyse',
      idealProfile: 'Profil d\'investisseur idéal',
      strengths: 'Points forts',
      risks: 'Risques principaux',
      viewAnalysis: 'Voir l\'analyse complète par quartier',
      footerNote: 'Les scores sont des estimations éditoriales basées sur des indices publics (FipeZAP, Zillow, T1 2025). Ils ne constituent pas un conseil financier.',
      of10: 'sur 10',
      currency: 'Devise',
      entryPrice: 'Prix d\'entrée (min.)',
      avgPrice: 'Prix moyen',
      topMarket: 'Haut de marché',
      yoyAppreciation: 'Valorisation annuelle',
      rentalYield: 'Rendement locatif',
      recommendedHorizon: 'Horizon recommandé',
      marketLiquidity: 'Liquidité du marché',
      appreciationPotential: 'Potentiel de valorisation',
      passiveIncome: 'Revenu passif',
      faqBadge: 'FAQ',
      viewAllFaqs: 'Voir toutes les questions dans le centre FAQ',
      exploreBadge: 'Market Guide',
      exploreTitle: 'Explorez d\'autres marchés',
      exploreSubtitle: 'Analyse détaillée des principales destinations d\'investissement immobilier.',
      exploreViewAll: 'Voir tous les marchés',
      avgPriceLabel: 'Prix moyen',
      yoyLabel: 'Valorisation annuelle',
      viewFullGuide: 'Voir le guide complet',
      colRank: '#',
      colNeighborhood: 'Quartier',
      colPrice: 'Prix moyen',
      colYoY: 'Var. annuelle',
      colProfile: 'Profil',
      colListings: 'Annonces',
      hot: 'Hot',
      top: 'Top',
      currencyLabel: 'Devise',
      ctaWhatsapp: 'Parler à un expert maintenant',
      falarConsultor: 'Parler à un consultant',
    },
    miami: {
      heroBadge: 'Miami · Floride',
      heroTitle: 'Meilleurs quartiers de Miami',
      heroTitleHighlight: 'pour investir en 2025',
      heroDescription: 'Miami s\'est imposée comme la première destination d\'investissement immobilier pour les Brésiliens aux États-Unis. Avec des prix moyens supérieurs à 1 000 $/sq ft, une valorisation historique à deux chiffres et une absence d\'impôt d\'État sur le revenu, la ville offre l\'un des meilleurs rendements ajustés au risque au monde.',
      heroCtaProperties: 'Voir les biens à Miami',
      heroCtaContact: 'Parler à un consultant',
      location: 'Miami, FL',
      countryLabel: 'Floride, États-Unis',
      currencyA: 'USD · Dollar américain',
      currencyB: 'BRL · Réal brésilien',
      strengthsA: ['0% impôt d\'État FL', 'Location courte durée viable', 'Marché international', 'Couverture de change BRL/USD', 'Valorisation cumulée +54% (5 ans)'],
      strengthsB: ['Plus grand marché d\'Amérique latine', 'Liquidité maximale', 'Diversité des quartiers et gammes', 'Hub corporate Faria Lima'],
      risksA: ['Risque de change (BRL/USD)', 'Coûts d\'entretien élevés', 'Assurances obligatoires (ouragans)', 'Bureaucratie pour non-résidents'],
      risksB: ['ITBI + charge fiscale élevée', 'Offre élevée dans certains quartiers', 'Valorisation plus progressive'],
      idealProfileA: 'Diversification internationale, protection de change et horizon à long terme (5–10 ans)',
      idealProfileB: 'Liquidité maximale, diversité des quartiers et exposition au plus grand hub financier d\'Amérique latine',
      entryPriceA: 'US$ 400 000',
      entryPriceB: 'R$ 350 000',
      avgPriceA: 'US$ 1 100/sq ft',
      avgPriceB: 'R$ 11 800/m²',
      topMarketA: 'US$ 3 800/sq ft · Bal Harbour',
      topMarketB: 'R$ 32 000/m² · Cidade Jardim',
      yieldA: '5–8% par an',
      yieldB: '4–6% par an',
      horizonA: '5–10 ans',
      horizonB: '3–10 ans',
      liquidityA: '9.2',
      liquidityB: '10.0',
      appreciationA: '9.0',
      appreciationB: '7.0',
      passiveIncomeA: '8.0',
      passiveIncomeB: '7.0',
      overallScoreA: '8.7',
      overallScoreB: '8.0',
      scoreWidthA: '87%',
      scoreWidthB: '80%',
      viewGuideA: 'Voir le guide de Miami',
      viewGuideB: 'Voir le guide de São Paulo',
      whyInvestTitle: 'Pourquoi investir à Miami ?',
      whyInvestSubtitle: '4 raisons qui font de Miami la première destination d\'investissement immobilier pour les Brésiliens aux États-Unis.',
      neighborhoodsTitle: 'Quartiers de Miami — Analyse complète',
      neighborhoodsSubtitle: 'Cliquez sur un quartier pour voir les prix détaillés, les scores et les points forts du marché.',
      rankingTitle: 'Classement des prix — Quartiers de Miami',
      rankingSubtitle: 'Comparatif classé par prix moyen au sq ft · T1 2025',
      howToBuyBadge: 'Guide pour les Brésiliens',
      howToBuyTitle: 'Comment acheter un bien à Miami en étant brésilien',
      howToBuySubtitle: 'Guide étape par étape pour les investisseurs brésiliens souhaitant acquérir un bien immobilier aux États-Unis en toute sécurité juridique et efficacité fiscale.',
      howToBuyHelpTitle: 'Besoin d\'aide pour tout ce processus ?',
      howToBuyHelpSubtitle: 'Notre équipe accompagne les Brésiliens de l\'ITIN à la remise des clés — sans frais supplémentaires.',
      howToBuyHelpCTA: 'Parler à un spécialiste',
      faqTitle: 'Questions sur l\'investissement à Miami',
      faqSubtitle: 'Principales questions des investisseurs brésiliens sur l\'achat immobilier à Miami — répondues par des spécialistes.',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Capitale fédérale avec le revenu par habitant le plus élevé du Brésil, patrimoine UNESCO et marché résilient.',
      exploreCardBrasiliaBadge: 'District Fédéral',
      exploreCardBrasiliaPrice: 'R$12 000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Plus forte hausse de l\'année',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Plus grand marché immobilier d\'Amérique latine. Faria Lima, Itaim Bibi et l\'axe de valorisation continue.',
      exploreCardSPBadge: 'São Paulo, Brésil',
      exploreCardSPPrice: 'R$11 800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Valorisation annuelle',
      ctaTitle: 'Prêt à investir à Miami ?',
      ctaSubtitle: 'Notre équipe spécialisée dans l\'immobilier à Miami accompagne les Brésiliens depuis plus de 9 ans. De l\'ITIN à la remise des clés.',
      ctaSecondary: 'Voir les biens à Miami',
    },
    saoPaulo: {
      heroBadge: 'São Paulo · SP',
      heroTitle: 'Meilleurs quartiers de São Paulo',
      heroTitleHighlight: 'pour investir en 2025',
      heroDescription: 'São Paulo est la capitale financière du Brésil et le plus grand marché immobilier d\'Amérique latine. Avec plus de 12 millions d\'habitants, un PIB équivalent à celui de pays entiers et une valorisation moyenne de +8,7% en 2025, la ville offre des opportunités uniques aux investisseurs recherchant des revenus, une valorisation ou une diversification patrimoniale.',
      heroCtaProperties: 'Voir les biens à São Paulo',
      heroCtaContact: 'Parler à un consultant',
      location: 'São Paulo, SP',
      countryLabel: 'São Paulo, Brésil',
      currencyA: 'BRL · Réal brésilien',
      currencyB: 'USD · Dollar américain',
      strengthsA: ['Plus grand marché d\'Amérique latine', 'Liquidité maximale', 'Diversité des quartiers et gammes', 'Hub corporate Faria Lima'],
      strengthsB: ['0% impôt d\'État FL', 'Location courte durée viable', 'Marché international', 'Couverture de change BRL/USD', 'Valorisation cumulée +54% (5 ans)'],
      risksA: ['ITBI + charge fiscale élevée', 'Offre élevée dans certains quartiers', 'Valorisation plus progressive'],
      risksB: ['Risque de change (BRL/USD)', 'Coûts d\'entretien élevés', 'Assurances obligatoires (ouragans)', 'Bureaucratie pour non-résidents'],
      idealProfileA: 'Liquidité maximale, diversité des quartiers et exposition au plus grand hub financier d\'Amérique latine',
      idealProfileB: 'Diversification internationale, protection de change et horizon à long terme (5–10 ans)',
      entryPriceA: 'R$ 350 000',
      entryPriceB: 'US$ 400 000',
      avgPriceA: 'R$ 11 800/m²',
      avgPriceB: 'US$ 1 100/sq ft',
      topMarketA: 'R$ 32 000/m² · Cidade Jardim',
      topMarketB: 'US$ 3 800/sq ft · Bal Harbour',
      yieldA: '4–6% par an',
      yieldB: '5–8% par an',
      horizonA: '3–10 ans',
      horizonB: '5–10 ans',
      liquidityA: '10.0',
      liquidityB: '9.2',
      appreciationA: '7.0',
      appreciationB: '9.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '8.0',
      overallScoreA: '8.0',
      overallScoreB: '8.7',
      scoreWidthA: '80%',
      scoreWidthB: '87%',
      viewGuideA: 'Voir le guide de São Paulo',
      viewGuideB: 'Voir le guide de Miami',
      whyInvestTitle: 'Pourquoi investir à São Paulo ?',
      whyInvestSubtitle: '4 raisons qui font de São Paulo la plus grande destination d\'investissement immobilier d\'Amérique latine.',
      neighborhoodsTitle: 'Quartiers de São Paulo — Analyse complète',
      neighborhoodsSubtitle: 'Cliquez sur un quartier pour voir les prix détaillés, les scores et le profil du marché.',
      rankingTitle: 'Classement des prix — Quartiers de São Paulo',
      rankingSubtitle: 'Comparatif classé par prix moyen au m² · 2025',
      faqTitle: 'Questions sur l\'immobilier à São Paulo',
      faqSubtitle: 'Principales questions des acheteurs et investisseurs sur le plus grand marché immobilier d\'Amérique latine.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'La première destination des Brésiliens aux États-Unis — dollar fort, rendement élevé et marché international.',
      exploreCardMiamiBadge: 'Floride, États-Unis',
      exploreCardMiamiPrice: '$1 100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Valorisation annuelle',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Capitale fédérale avec le revenu par habitant le plus élevé du Brésil, patrimoine UNESCO et marché résilient.',
      exploreCardBrasiliaBadge: 'District Fédéral',
      exploreCardBrasiliaPrice: 'R$12 000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Plus forte hausse de l\'année',
      ctaTitle: 'Prêt à investir à São Paulo ?',
      ctaSubtitle: 'Notre équipe spécialisée dans le marché paulistano vous accompagne du choix du quartier à la signature du contrat — sans frais supplémentaires.',
      ctaSecondary: 'Voir les biens à São Paulo',
    },
    brasilia: {
      heroBadge: 'Brasília · District Fédéral',
      heroTitle: 'Meilleurs quartiers de Brasília',
      heroTitleHighlight: 'pour acheter un bien en 2025',
      heroDescription: 'Brasília a enregistré une croissance de 12,6% des prix des biens neufs en 2025 — la plus élevée parmi les capitales brésiliennes. Capitale fédérale avec l\'un des revenus par habitant les plus élevés du Brésil, une demande publique stable et une offre naturellement restreinte par la protection urbanistique, la ville est l\'un des marchés les plus résilients du pays.',
      heroCtaProperties: 'Voir les biens à Brasília',
      heroCtaContact: 'Parler à un consultant',
      location: 'Brasília, DF',
      countryLabel: 'District Fédéral, Brésil',
      currencyA: 'BRL · Réal brésilien',
      currencyB: 'BRL · Réal brésilien',
      strengthsA: ['Offre limitée par l\'UNESCO', 'Revenu par habitant le plus élevé du BR', 'Demande publique stable', 'Marché résilient en crise'],
      strengthsB: ['Plus grand marché d\'Amérique latine', 'Liquidité maximale', 'Diversité des quartiers et gammes', 'Hub corporate Faria Lima'],
      risksA: ['Liquidité plus régionale', 'Dépendance aux budgets fédéraux', 'Marché moins diversifié'],
      risksB: ['ITBI + charge fiscale élevée', 'Offre élevée dans certains quartiers', 'Valorisation plus progressive'],
      idealProfileA: 'Profil conservateur recherchant une sécurité patrimoniale et des revenus stables de fonctionnaires',
      idealProfileB: 'Liquidité maximale, diversité des quartiers et exposition au plus grand hub financier d\'Amérique latine',
      entryPriceA: 'R$ 450 000',
      entryPriceB: 'R$ 350 000',
      avgPriceA: 'R$ 12 000/m²',
      avgPriceB: 'R$ 11 800/m²',
      topMarketA: 'R$ 16 500/m² · Sudoeste',
      topMarketB: 'R$ 32 000/m² · Cidade Jardim',
      yieldA: '~5% par an',
      yieldB: '4–6% par an',
      horizonA: '3–7 ans',
      horizonB: '3–10 ans',
      liquidityA: '7.0',
      liquidityB: '10.0',
      appreciationA: '8.0',
      appreciationB: '7.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '7.0',
      overallScoreA: '7.3',
      overallScoreB: '8.0',
      scoreWidthA: '73%',
      scoreWidthB: '80%',
      viewGuideA: 'Voir le guide de Brasília',
      viewGuideB: 'Voir le guide de São Paulo',
      whyInvestTitle: 'Pourquoi investir à Brasília ?',
      whyInvestSubtitle: '4 facteurs structurels qui font de Brasília l\'un des marchés immobiliers les plus résilients du Brésil.',
      neighborhoodsTitle: 'Quartiers de Brasília — Analyse complète',
      neighborhoodsSubtitle: 'Cliquez sur un quartier pour voir les prix détaillés, les scores et le profil du marché.',
      rankingTitle: 'Classement des prix — Quartiers de Brasília',
      rankingSubtitle: 'Comparatif classé par prix moyen au m² · 2025',
      faqTitle: 'Questions sur l\'immobilier à Brasília',
      faqSubtitle: 'Principales questions des acheteurs et investisseurs sur le marché immobilier de Brasília et du District Fédéral.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'La première destination des Brésiliens aux États-Unis — dollar fort, rendement élevé et marché international.',
      exploreCardMiamiBadge: 'Floride, États-Unis',
      exploreCardMiamiPrice: '$1 100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Valorisation annuelle',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Plus grand marché immobilier d\'Amérique latine. Faria Lima, Itaim Bibi et l\'axe de valorisation continue.',
      exploreCardSPBadge: 'São Paulo, Brésil',
      exploreCardSPPrice: 'R$11 800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Valorisation annuelle',
      ctaTitle: 'Prêt à investir à Brasília ?',
      ctaSubtitle: 'Notre équipe spécialisée dans le marché du DF vous accompagne du choix du quartier à la signature du contrat — sans frais supplémentaires.',
      ctaSecondary: 'Voir les biens à Brasília',
    },
  },
};

export default guia;